// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  padding: 20px;
  border-radius: 8px;
  max-width: 800px;
  margin: auto;
  font-size: 15.24px; /* Set font size globally to 15.24px */
}

.section-title {
  font-size: 15.24px; /* Matches the body text size */
}

.instructions {
  margin-bottom: 1em;
}

.subtext {
  margin-bottom: 0.5em;
}

.list {
  list-style-type: disc;
  padding-left: 20px;
}

h4 {
  font-size: 15.24px; /* Set header font size to 15.24px */
  margin-top: 1.5em;
}

strong {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/components/examComponents/MathDirections.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA,EAAA,sCAAA;AACF;;AAEA;EACE,kBAAA,EAAA,+BAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,qBAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA,EAAA,oCAAA;EACA,iBAAA;AACF;;AAEA;EACE,iBAAA;AACF","sourcesContent":[".container {\n  padding: 20px;\n  border-radius: 8px;\n  max-width: 800px;\n  margin: auto;\n  font-size: 15.24px; /* Set font size globally to 15.24px */\n}\n\n.section-title {\n  font-size: 15.24px; /* Matches the body text size */\n}\n\n.instructions {\n  margin-bottom: 1em;\n}\n\n.subtext {\n  margin-bottom: 0.5em;\n}\n\n.list {\n  list-style-type: disc;\n  padding-left: 20px;\n}\n\nh4 {\n  font-size: 15.24px; /* Set header font size to 15.24px */\n  margin-top: 1.5em;\n}\n\nstrong {\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
